import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MedicineService } from 'src/core/services/medicine.service';
import { CreateDosageTypePayload, DosageType, DosageUnit } from 'src/interfaces/medicine';

export interface DialogData {
  title: string;
  message: string;
  dosageUnits: DosageUnit[];
}
@Component({
  selector: 'app-dosage-type-create-dialog',
  templateUrl: './dosage-type-create-dialog.component.html',
  styleUrls: ['./dosage-type-create-dialog.component.scss']
})
export class DosageTypeCreateDialogComponent implements OnInit {

  dosageTypeForm = this._formBuilder.group({
    type: ['', Validators.required],
    code: ['', Validators.required],
    dosageUnit: ['', Validators.required]
  });

  dosageUnits: DosageUnit[];

  constructor(
    public _dialogRef: MatDialogRef<DosageTypeCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: FormBuilder,
    private _medicineService: MedicineService
  ) { }

  ngOnInit(): void {
    this.dosageUnits = this.data.dosageUnits;
  }

  async createDosageType() {

    const payload: CreateDosageTypePayload = {
      type: this.dosageTypeForm.value.type,
      code: this.dosageTypeForm.value.code,
      dosage_unit_id: this.dosageTypeForm.value.dosageUnit.id
    };

    const createdDosageType: DosageType | null = await this._medicineService
      .createDosageType(payload)

    if (createdDosageType)
      this._dialogRef.close(createdDosageType);
  }

  async createDosageUnit(event: Event) {
    event.stopPropagation();
    const newDosageUnit: DosageUnit = await this._medicineService
      .openDosageUnitCreateDialog(
        "New dosage unit",
        "Create a new dosage unit",

      );

    if (newDosageUnit) {
      // add dosage unit to the list dosage units 
      this.dosageUnits.push(newDosageUnit);
      // clone array 
      this.dosageUnits = [...this.dosageUnits];
      // Update the form value to the newly created dosage unit
      this.dosageTypeForm.patchValue({
        dosageUnit: newDosageUnit
      });
    }
  }

  async deleteDosageUnit(unit: DosageUnit){
    const success: boolean = await this._medicineService.deleteDosageUnit(unit.id);

    if(success)
        this.dosageUnits = this.dosageUnits.filter(dosageUnit => dosageUnit.id !== unit.id);
  }

}
